import { Constants } from '../../constants';
import {
  ScanFields,
  ScanMetaFields,
  ScanToolkitOutputFields,
} from '../../../firebase/document-field.enums';
import {
  scanProcessingToolkitErrorCodes,
  scanProcessingToolkitWarningCodes,
} from '../../utils/services/scan-data-utils';
import { FilterModel, FilterOption } from './filter.model';
import { FilterType } from './filter.type';
import { YES_NO_FILTER_OPTIONS } from './yes-no-filter-options';

const OPTION_SEARCH = {
  label: 'common.listFilters.searchOptions',
  emptyLabel: 'common.listFilters.noOptionMatches',
};

const HAS_ISSUE_OPTIONS: FilterOption[] = [
  { label: 'common.actions.yes', value: '1', translate: true },
  { label: 'common.actions.no', value: '0', translate: true },
];

const toCodeOptions = (codes: Record<string, string>): FilterOption[] =>
  Object.entries(codes).map(([value, label]) => ({
    value,
    label,
    secondaryLabel: value,
  }));

export const SCAN_LIST_FILTERS: FilterModel[] = [
  {
    fieldName: ScanFields.userId,
    label: 'common.scanDetails.results.userId',
    type: FilterType.text,
    value: '',
  },
  {
    fieldName: ScanFields.lot_id,
    label: 'common.scanDetails.results.lotId',
    type: FilterType.select,
    search: OPTION_SEARCH,
    value: '',
  },
  {
    fieldName: ScanToolkitOutputFields.toolkit_version,
    label: 'common.scanDetails.results.toolkitVersion',
    type: FilterType.text,
    value: '',
  },
  {
    fieldName: ScanFields.lh,
    label: 'common.dailyData.lh',
    type: FilterType.slider,
    min: Constants.LH_MIN,
    max: Constants.LH_MAX + 0.5,
    value: '',
  },
  {
    fieldName: ScanFields.pg,
    label: 'common.dailyData.pg',
    type: FilterType.slider,
    min: Constants.PG_MIN,
    max: Constants.PG_MAX + 0.5,
    value: '',
  },
  {
    fieldName: ScanFields.lr_e3g,
    label: 'common.dailyData.e3g',
    type: FilterType.slider,
    min: Constants.LR_E3G_MIN,
    max: Constants.LR_E3G_MAX + 0.5,
    value: '',
  },
  {
    fieldName: ScanToolkitOutputFields.warning_code,
    label: 'common.scanDetails.results.warning',
    type: FilterType.select,
    search: OPTION_SEARCH,
    options: toCodeOptions(scanProcessingToolkitWarningCodes),
    value: '',
  },
  {
    fieldName: ScanToolkitOutputFields.error_code,
    label: 'common.scanDetails.results.error',
    type: FilterType.select,
    search: OPTION_SEARCH,
    options: toCodeOptions(scanProcessingToolkitErrorCodes),
    value: '',
  },
  {
    fieldName: ScanToolkitOutputFields.warning,
    label: 'scanList.hasWarning',
    type: FilterType.radio,
    options: HAS_ISSUE_OPTIONS,
    value: '',
  },
  {
    fieldName: ScanToolkitOutputFields.error,
    label: 'scanList.hasError',
    type: FilterType.radio,
    options: HAS_ISSUE_OPTIONS,
    value: '',
  },
  {
    fieldName: ScanMetaFields.os,
    label: 'common.os',
    type: FilterType.radio,
    options: [
      { label: 'IOS', value: 'ios' },
      { label: 'Android', value: 'android' },
    ],
    value: '',
  },
  {
    fieldName: ScanMetaFields.app_version,
    label: 'common.appVersion',
    type: FilterType.select,
    search: OPTION_SEARCH,
    value: '',
  },
  {
    fieldName: ScanMetaFields.device_model,
    label: 'common.deviceModel',
    type: FilterType.select,
    search: OPTION_SEARCH,
    value: '',
  },
  {
    fieldName: ScanFields.is_demo_scan,
    label: 'scans.demo',
    type: FilterType.radio,
    options: YES_NO_FILTER_OPTIONS,
    value: '',
  },
];
